import { ApiClientImplementation } from 'infra/api-client/api-client'
import {
  getCurrentHospitalAdapter,
  setCurrentHospitalAdapter
} from 'main/adapters/current-hospital/current-hospital-adapter'
import { setCurrentUserAdapter } from 'main/adapters/current-user/current-user-adapter'
import { PrepareApiRequestDecorator } from 'main/decorators/prepare-api-request-decorator/prepare-api-request-decorator'
import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'
import CurrentHospital from 'presentation/contexts/current-hospital/current-hospital-context'
import { ApiRepository } from 'repository/api-repository'
import { HospitalRepository } from 'repository/repositories/hospital/hospital-repository'
import { RemoteChangeHospital } from 'service/usecases/change-hospital/remote-change-hospital'
import { RemoteLoadHospitals } from 'service/usecases/load-hospitals/remote-load-hospitals'

export default function makeCurrentHospital() {
  const apiClient = new ApiClientImplementation()
  const apiRepository = new PrepareApiRequestDecorator(
    makeLocalStorageAdapter(),
    new ApiRepository(apiClient)
  )

  const hospitalRepository = new HospitalRepository(apiRepository)

  const loadHospitals = new RemoteLoadHospitals(hospitalRepository)
  const changeHospital = new RemoteChangeHospital(hospitalRepository)

  return new CurrentHospital(
    setCurrentHospitalAdapter,
    getCurrentHospitalAdapter,
    setCurrentUserAdapter,
    loadHospitals,
    changeHospital
  )
}
